export const stylesRowOpenedNoBorder = {
   cellClosed: {},
   cellOpened: {
      borderBottom: '0px',
      borderCollapse: 'separate',
   },
}

export const stylesRowClosedNoBorder = {
   cellClosed: {
      borderBottom: '0px',
      borderCollapse: 'separate',
   },
   cellOpened: {},
}
